<div class="row mx-0">
    <div class="col p-0">
      <select
        class="ag_grid_custom_dropdown cursor-pointer ps-2"
        id="custom_select_options" 
        [(ngModel)]="value" 
        (ngModelChange)="selected($event)">
        <option *ngIf="isBlankOption"></option>
        <option *ngFor="let val of values" [value]="val.id">
          {{ val.name }}
        </option>
      </select>
    </div>
  </div>